import { useMutation, useQuery } from '@tanstack/react-query';

import { queries } from '@/queries';
import { postMindCoinsCheckout } from '@/services/mindCoins';

import { useProfile } from './useProfile';

export const useMindCoins = () => {
  const { data: profileData } = useProfile();
  return useQuery({
    ...queries.payments.mindCoins,
    enabled: !!profileData,
  });
};

export const useMindCoinsCheckout = () =>
  useMutation({
    mutationFn: postMindCoinsCheckout,
    mutationKey: ['postMindCoinsCheckout'],
    onSuccess: ({ url }) => {
      window.location.href = url;
    },
  });
